const MEVERSE = 0;

export default {
    '0x1d5e': MEVERSE,
    '0x1297': MEVERSE,
    MEVERSE,
}